uniform vec2 resolution;
uniform float time;
varying vec2 vUv;

#pragma glslify: quadraticInOut = require(glsl-easings/quadratic-in-out)

float circle(vec2 p, vec2 offset) {
    vec2 circleP = p + offset;
    circleP.x *= 0.8;
    float circle = 1.0 - clamp(length(circleP), 0.0, 200.0) / 200.0;
    circle = quadraticInOut(circle);
    return circle;
}

vec4 blendNormal(vec4 base, vec4 blend) {
    // Calculate the alpha of the output color
    float outAlpha = blend.a + base.a * (1.0 - blend.a);

    // Blend the colors
    vec3 outColor = (blend.rgb * blend.a + base.rgb * base.a * (1.0 - blend.a)) / outAlpha;

    return vec4(outColor, outAlpha);
}

vec4 blendLuma(vec4 base, vec4 blend) {
    // Calculate the luminance of the blend color
    float luma = dot(blend.rgb, vec3(0.299, 0.587, 0.114));
    
    // Interpolate between the base color and the blend color using the luminance
    vec3 outColor = mix(base.rgb, blend.rgb, luma);
    
    // Output alpha is the max of the two alphas
    float outAlpha = max(base.a, blend.a);

    return vec4(outColor, outAlpha);
}

vec4 blendDifference(vec4 base, vec4 blend) {
    // Calculate the difference blend
    vec3 outColor = abs(base.rgb - blend.rgb);
    
    // Output alpha is the max of the two alphas
    float outAlpha = max(base.a, blend.a);

    return vec4(outColor, outAlpha);
}

vec4 blendMultiply(vec4 base, vec4 blend) {
    vec3 outColor = base.rgb * blend.rgb;
    float outAlpha = max(base.a, blend.a);
    return vec4(outColor, outAlpha);
}

vec4 blendScreen(vec4 base, vec4 blend) {
    vec3 outColor = 1.0 - ((1.0 - base.rgb) * (1.0 - blend.rgb));
    float outAlpha = max(base.a, blend.a);
    return vec4(outColor, outAlpha);
}

vec4 blendOverlay(vec4 base, vec4 blend) {
    vec3 outColor = mix(2.0 * base.rgb * blend.rgb, 1.0 - 2.0 * (1.0 - base.rgb) * (1.0 - blend.rgb), step(0.5, base.rgb));
    float outAlpha = max(base.a, blend.a);
    return vec4(outColor, outAlpha);
}

vec4 blendDarken(vec4 base, vec4 blend) {
    vec3 outColor = min(base.rgb, blend.rgb);
    float outAlpha = max(base.a, blend.a);
    return vec4(outColor, outAlpha);
}

vec4 blendLighten(vec4 base, vec4 blend) {
    vec3 outColor = max(base.rgb, blend.rgb);
    float outAlpha = max(base.a, blend.a);
    return vec4(outColor, outAlpha);
}

vec4 blendColorDodge(vec4 base, vec4 blend) {
    vec3 outColor = base.rgb / (1.0 - blend.rgb);
    float outAlpha = max(base.a, blend.a);
    return vec4(outColor, outAlpha);
}

vec4 blendHardLight(vec4 base, vec4 blend) {
    vec3 outColor = mix(2.0 * base.rgb * blend.rgb, 1.0 - 2.0 * (1.0 - base.rgb) * (1.0 - blend.rgb), step(0.5, blend.rgb));
    float outAlpha = max(base.a, blend.a);
    return vec4(outColor, outAlpha);
}

vec4 blendSoftLight(vec4 base, vec4 blend) {
    vec3 outColor = (1.0 - base.rgb) * base.rgb * blend.rgb + base.rgb * (1.0 - (1.0 - base.rgb) * (1.0 - blend.rgb));
    float outAlpha = max(base.a, blend.a);
    return vec4(outColor, outAlpha);
}

vec4 blendExclusion(vec4 base, vec4 blend) {
    vec3 outColor = base.rgb + blend.rgb - 2.0 * base.rgb * blend.rgb;
    float outAlpha = max(base.a, blend.a);
    return vec4(outColor, outAlpha);
}

void main() {
    vec2 uv = vUv - 0.5;
    vec2 p = uv * resolution;

    float circleTop = circle(p, vec2(0.0, -80.0));
    float circleBottom = circle(p, vec2(0.0, 80.0));

    vec4 background = vec4(0.0);
    vec3 topColor = vec3(0.96, 0.96, 0.19);
    vec4 circleTopColor = vec4(topColor, circleTop );
    vec3 bottomColor = vec3(0.93, 0.2, 0.75);
    vec4 circleBottomColor = vec4(bottomColor, circleBottom);

    vec4 outColor = blendExclusion(background, circleBottomColor);
    outColor = blendExclusion(outColor, circleTopColor);

    gl_FragColor = outColor;
}